<template>
    <b-row align-v="center">
        <template v-if="isPatientView && settingLoaded">
            <TreatmentPatient
                :loading="singleLoading"
                :dialogs="dialogs"
                :treatment="treatment"
        /></template>
        <template v-else-if="!isPatientView">
            <b-col md="6">
                <b-form inline>
                    <h1 class="my-3 ml-3">
                        <img
                            src="assets/daysmartvet_logo_dark.svg"
                            width="37"
                            v-if="_isTvView"
                        />
                        Treatment Board
                    </h1>
                    <div
                        v-if="isClinicInNewTreatmentBoardBeta"
                        class="green-toggle custom-control custom-switch ml-3 cursor-pointer"
                    >
                        <input
                            id="toNewTreatmentBoard"
                            type="checkbox"
                            class="custom-control-input cursor-pointer"
                            :disabled="disableButton"
                            v-model="useNewTreatmentBoard"
                        />
                        <label
                            class="custom-control-label cursor-pointer"
                            for="toNewTreatmentBoard"
                        >
                            {{ treatmentBoardVersion }}
                        </label>
                    </div>
                </b-form>
            </b-col>
            <!-- treatment board accessories button -->
            <b-col class="text-right" md="6">
                <div class="d-flex align-items-center justify-content-end">
                    <remote-view-link
                        class="justify-content-end"
                        :mod="EXTERNALVIEW.TREATMENT"
                        :useNewTreatmentBoard="useNewTreatmentBoard"
                        @change-treatment-view="
                            value => (treatmentBoardView = value)
                        "
                    />
                    <!-- SEARCH FUNCTION HERE -->
                    <input-search-icon
                        v-if="useNewTreatmentBoard && !_isTvView"
                        ref="inputSearchIcon"
                        class="mr-2"
                        :stretchSize="true"
                        placeholder="Search Patients"
                        @search="searchPatient"
                    >
                        <!--Work in progress-->
                    </input-search-icon>
                    <b-button-group>
                        <b-button
                            v-if="!_isTvView"
                            id="sort-button"
                            :disabled="disableSort"
                            v-b-tooltip.hover.bottom
                            title="Sort treatment board"
                            ><i
                                v-if="iconDown"
                                class="fas fa-sort-amount-down-alt"
                            ></i
                            ><i v-else class="fas fa-sort-amount-down"></i
                        ></b-button>
                        <b-button
                            v-if="useNewTreatmentBoard && !_isTvView"
                            class="mr-2 d-flex align-items-center"
                            id="filter-button-v2"
                            v-b-tooltip.hover.bottom
                            title="Filter treatment board"
                            @click="togglePopOver"
                            :disabled="loading"
                            ><i class="fas fa-filter mr-1"></i>
                            <span
                                v-if="filterSelect.length > 0"
                                class="filter-badge"
                                >{{ filterSelect.length }}</span
                            ></b-button
                        >
                        <b-button
                            v-else-if="!_isTvView"
                            class="mr-2 d-flex align-items-center"
                            id="filter-button"
                            v-b-tooltip.hover.bottom
                            title="Filter treatment board"
                            @click="togglePopOver"
                            :disabled="loading"
                            ><i class="fas fa-filter mr-1"></i>
                            <span
                                v-if="filterSelect.length > 0"
                                class="filter-badge"
                                >{{ filterSelect.length }}</span
                            ></b-button
                        >
                    </b-button-group>
                    <div
                        v-if="useNewTreatmentBoard && !_isTvView"
                        class="btn-group"
                        role="group"
                        aria-label="Add new or jump to"
                    >
                        <TreatmentActionsDropdown> </TreatmentActionsDropdown>
                    </div>
                    <div
                        v-if="
                            useNewTreatmentBoard &&
                            treatmentBoardView == 'timeline' &&
                            !_isTvView
                        "
                        class="btn-group mx-1 button-arrow"
                        role="group"
                        aria-label="Scroll right or left as well as a calendar"
                    >
                        <button
                            type="button"
                            class="btn btn-secondary"
                            v-b-tooltip.hover.top
                            title="Navigate timeline to the left"
                            @click="
                                $refs.treatmentBoardNew.onNavigateButtonClick(
                                    false
                                )
                            "
                        >
                            <span
                                class="fc-icon fc-icon-chevron-left font-weight-bolder"
                            ></span>
                        </button>
                        <button
                            type="button"
                            id="treatment-calendar-button"
                            v-b-tooltip.hover.top
                            title="Select date from calendar"
                            class="btn btn-secondary"
                        >
                            <span class="far fa-calendar"></span>
                        </button>
                        <button
                            type="button"
                            class="btn btn-secondary"
                            v-b-tooltip.hover.top
                            title="Navigate timeline to the right"
                            @click="
                                $refs.treatmentBoardNew.onNavigateButtonClick()
                            "
                        >
                            <span
                                class="fc-icon fc-icon-chevron-right font-weight-bolder"
                            ></span>
                        </button>
                    </div>
                    <button
                        v-if="_isTvView"
                        class="btn btn-outline mr-2"
                        @click="$emit('toggle-full-screen')"
                        v-b-tooltip.hover.bottom="{
                            title: fullscreen
                                ? 'Exit Full-Screen'
                                : 'Toggle Full-Screen',
                            container: '#fullscreen-container'
                        }"
                    >
                        <i
                            v-if="fullscreen"
                            class="fas fa-compress-arrows-alt"
                        ></i>
                        <i v-else class="fas fa-expand-arrows-alt"></i>
                    </button>
                </div>
            </b-col>

            <b-container fluid>
                <div v-if="useNewTreatmentBoard">
                    <div v-if="isLoadingFilter || loading" class="px-3">
                        <loader />
                    </div>
                    <TreatmentRowNew
                        v-else
                        :treatments="treatmentsFilter"
                        :dialogs="dialogs"
                        :filter="filter"
                        :treatmentBoardView="
                            _isTvView ? 'activity' : treatmentBoardView
                        "
                        @navigate-to-patient="navigateToPatient"
                        @get-filter-options="
                            filteredTreatments =>
                                $refs.filterTreatmentBoardV2.getFilterOptions(
                                    filteredTreatments
                                )
                        "
                        ref="treatmentBoardNew"
                    />
                </div>
                <div v-else>
                    <div v-if="isLoadingFilter && loading" class="px-3">
                        <loader />
                    </div>
                    <div v-else>
                        <TreatmentRow
                            v-for="treatment in treatmentsFilter"
                            :key="treatment.id"
                            :data="treatment"
                            :dialogs="dialogs"
                            :isLoadingGetTreatmentList="loadingTriageRow"
                        />
                        <div v-if="loading">
                            <img src="assets/ajax-loader.gif" />
                        </div>
                        <b-card v-else-if="treatmentsFilter.length === 0" class>
                            <cite>No admitted patients</cite>
                        </b-card>
                    </div>
                </div>
            </b-container>
            <router-view />
            <treatment-calendar
                v-if="useNewTreatmentBoard && treatmentBoardView == 'timeline'"
                ref="treatmentCalendar"
                :target="'treatment-calendar-button'"
                @refresh="
                    date => $refs.treatmentBoardNew.setToSelectedDate(date)
                "
                @set-to-current-time="
                    $refs.treatmentBoardNew.setToCurrentTime()
                "
                @disabled-button="val => (disableTreatmentCalendar = val)"
            />
        </template>
        <delete-activity ref="deleteActivityModal" />
        <start-activity ref="startModal" />
        <edit-activity ref="editModal" />
        <create-update-record
            ref="createUpdateRecordModal"
            @activity-action="activityAction"
        />
        <view-document ref="documentModal" />
        <new-vital ref="newVitalModal" @activity-action="activityAction" />
        <discharge ref="dischargeModal" :instanceId="instanceId" />
        <start-task ref="startTaskModal" @activity-action="activityAction" />
        <treatment-status ref="statusModal" />
        <activity-summary
            ref="summaryModal"
            @activity-action="activityAction"
        />
        <activity-history ref="modalActivityHistory" />
        <remove-treatment ref="removeTreatmentModal" />
        <multipleRequisitionForm ref="multipleRequisitionFormWindow" />
        <sort-treatment-board
            v-if="!isPatientView"
            :key="treatmentBoardVersion"
            ref="sortTreatmentBoard"
            :target="'sort-button'"
            :treatments="treatments"
            :treatmentFilter="filter"
            :activityStatus="TREATMENT_ACTIVITY_STATUS"
            @refresh="refreshTreatmentBoard"
            @change-icon-down="val => (iconDown = val)"
            @disabled-button="val => (disableSort = val)"
        />
        <filter-treatment-board
            ref="filterTreatmentBoard"
            :target="'filter-button'"
            :filterOptionsObject="filterTreatmentOptions"
            :useNewTreatmentBoard="useNewTreatmentBoard"
            @hidden="incrementKeyComponent"
            @filter-data="filterData"
            @filter-selected="filterSelected"
        />
        <filter-treatment-board-v2
            ref="filterTreatmentBoardV2"
            :target="'filter-button-v2'"
            :treatments="treatments"
            :hasOvernightStay="Boolean(hasOvernightStay)"
            :treatmentStatusLabelled="TREATMENT_STATUS_LABELLED"
            @filter-data="filterData"
            @filter-selected="filterSelected"
        />
    </b-row>
</template>
<script>
// helper
import { get, find, some, isUndefined, forEach } from "lodash";

// components
import TreatmentRow from "./treatment";
import TreatmentRowNew from "./treatment-v2";
import TreatmentActionsDropdown from "./treatment-actions-dropdown";
import StartActivity from "./start";
import CreateUpdateRecord from "@/module/commons/record/create-update.vue";
import DeleteActivity from "./delete-activity";
import ViewDocument from "./document";
import Discharge from "./discharge";
import ActivitySummary from "./summary";
import TreatmentStatus from "./status";
import NewVital from "@/module/vital/new-multiple-vital";
import EditActivity from "./activity";
import StartTask from "./start-task";
import ActivityHistory from "./activity-history";
import uuidv4 from "uuid/v4";
import ScheduleHelper from "../helper";
import RemoveTreatment from "./remove-treatment";
import MultipleRequisitionForm from "@/module/commons/print_multiple_requisition_form.vue";
import CSETTINGS from "@/constants/settings";
import RemoteViewLink from "@/components/commons/remote-view-link";
import SortTreatmentBoard from "@/components/schedule-treatment/sort-treatment-board-popover";
import FilterTreatmentBoard from "@/components/schedule-treatment/filter-treatment-board-popover";
import FilterTreatmentBoardV2 from "@/components/schedule-treatment/filter-treatment-board-popover-v2";
import Loader from "@/components/elements/loader-card";
import InputSearchIcon from "@/module/commons/input-search-icon";
import TreatmentCalendar from "./treatment-calendar-popover";
import TreatmentPatient from "./treatment-patient";
import TreatmentActivityMixin from "@/mixins/treatment-activity-details";
import AccountService from "@/services/account.js";

export default {
    name: "TreatmentBoard",
    mixins: [ScheduleHelper, TreatmentActivityMixin],
    components: {
        TreatmentRow,
        StartActivity,
        EditActivity,
        CreateUpdateRecord,
        Discharge,
        NewVital,
        StartTask,
        ActivityHistory,
        ActivitySummary,
        TreatmentStatus,
        ViewDocument,
        DeleteActivity,
        RemoveTreatment,
        MultipleRequisitionForm,
        RemoteViewLink,
        SortTreatmentBoard,
        FilterTreatmentBoard,
        FilterTreatmentBoardV2,
        Loader,
        InputSearchIcon,
        TreatmentRowNew,
        TreatmentActionsDropdown,
        TreatmentCalendar,
        TreatmentPatient
    },
    props: {
        fullscreen: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            // filter: 0,
            filter: {},
            treatment: {},
            treatments: [],
            loading: true,
            instanceId: uuidv4(),
            currentLock: null,
            EXTERNALVIEW: CSETTINGS.EXTERNAL_VIEW,
            loadingTriageRow: {},
            treatmentsFilter: [],
            disableSort: false,
            iconDown: true,
            filterTreatmentOptions: {},
            disableFilter: false,
            filterSelect: [],
            isLoadingFilter: false,
            userPrefLoaded: false,
            keyComponent: 0,
            useNewTreatmentBoard: false,
            treatmentBoardVersion: "Legacy UI",
            disableButton: false,
            treatmentBoardView: "timeline",
            preventLoading: false,
            settingLoaded: false,
            singleLoading: true,
            updateSingleTreatment: null,
            isClinicInNewTreatmentBoardBeta: false,
            firstLoad: true,
            allowSwitchRefetch: false,
            treatmentsFiltered: null
        };
    },
    watch: {
        filter(value, oldValue) {
            if (
                value != oldValue &&
                this.userPrefLoaded &&
                !this.useNewTreatmentBoard
            ) {
                this.isLoadingFilter = true;
                this.getTreatments();
            }
        },
        useNewTreatmentBoard(status) {
            this.treatmentBoardVersion = status ? "New UI" : "Legacy UI";
            this.saveTreatmentBoardViewPreferences(Number(status));

            if (this.allowSwitchRefetch) {
                this.getTreatments();
            }
        },
        "$store.state.userPreferences.prefs"(value) {
            if (this.isClinicInNewTreatmentBoardBeta && this.firstLoad) {
                let userPref = value?.treatmentBoardView?.showOld;
                if (userPref === undefined) {
                    this.useNewTreatmentBoard = true;
                } else {
                    this.useNewTreatmentBoard = Boolean(userPref);
                }
                this.firstLoad = false;
            }
        },
        isPatientView: {
            handler(status) {
                if (status) {
                    this.getTreatment(this.$route.params.treatmentId);
                }
            },
            immediate: true
        }
    },
    computed: {
        hasOvernightStay() {
            return this.filterTreatmentOptions.overnight_stay;
        },
        statusList() {
            const all = {
                value: 0,
                text: "All treatments"
            };
            return [all].concat(
                some(this.$store.state.status)
                    ? this.TREATMENT_STATUS_ORDER.map(status =>
                          find(this.$store.state.status, {
                              index: status,
                              module_name: "schedule.treatment"
                          })
                      ).map(status => ({
                          value: status.index,
                          id: status.id,
                          text: status.value
                      }))
                    : []
            );
        },
        dialogs() {
            return this.$refs;
        },
        isPatientView() {
            return this.$route.name == "treatment.patient";
        }
    },
    async created() {
        await this.checkClinicInNewTreatmentBoardBeta(false);
    },
    async mounted() {
        // re-fetch soap pref to cater case user navigate away
        await this.$store.dispatch("userPreferences/initGetPrefs");
        this.userPrefLoaded = true;
        this._getSetting().then(async setting => {
            this.settingLoaded = true;
            await this.getTreatments();
            this.$socket.client.emit("v-broadcast", {
                action: "activity-check",
                businessId: setting.business_id
            });
        });

        this.$root.$on("treatment-board-refresh", id =>
            this.useNewTreatmentBoard
                ? this.newTreatmentBoardRefresh(id)
                : this.oriTreatmentBoardRefresh(id)
        );
        this.$root.$on("start-treatment", params => {
            if (params) {
                this.$refs.startModal.open(params);
            }
        });
    },
    sockets: {
        "v-broadcast"(params) {
            if (params.action === "refresh-treatment") {
                if (this.isPatientView) {
                    this.getTreatment(this.treatment.id);
                } else {
                    if (
                        params.treatmentId &&
                        !params.isRelatedToFilter &&
                        this.useNewTreatmentBoard
                    ) {
                        this.getTreatment(params.treatmentId, false);
                    } else {
                        this.getTreatments(this.useNewTreatmentBoard);
                    }
                }
            }

            if (params.action === "reroute-treatment-details") {
                this.$router.push({ name: "treatment" });
                this._message(
                    "The treatment was successfully removed by a user."
                );
            }

            if (params.action === "activity-check") {
                if (some(this.$store.state.locked_activity?.locked)) {
                    this.$socket.client.emit("v-broadcast", {
                        params: this.$store.state.locked_activity.locked,
                        action: "activity-lock",
                        businessId: this._setting.business_id
                    });
                }
            }

            if (params.action === "activity-lock") {
                let activities = find(this.treatments, {
                    id: params.params.treatment_id
                })?.activities;
                if (!isUndefined(activities)) {
                    this.$set(
                        find(activities, { id: params.params.id }),
                        "locked",
                        params.params
                    );
                }
                params.params.message =
                    "This activity currently being edited by " +
                    params.params.staff.fullname;
                this.$store.commit("locked_activity_add", params.params);
            }

            if (params.action === "activity-unlock") {
                let activities = find(this.treatments, {
                    id: params.params.treatment_id
                })?.activities;
                if (!isUndefined(activities)) {
                    this.$set(
                        find(activities, { id: params.params.id }),
                        "locked",
                        null
                    );
                }

                this.$store.commit("locked_activity_remove", params.params);
            }
        }
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm._getSetting().then(() => {
                vm._saveAudit({
                    action: "all",
                    ...to
                });
            });
        });
    },
    methods: {
        getTreatments(preventLoading = false) {
            this.loading = !preventLoading;
            let params = this.useNewTreatmentBoard ? {} : this.filter;
            params["new_treatment_board"] = Number(this.useNewTreatmentBoard);
            return this.$http
                .get(process.env.BARRACUDA + "schedule/treatment-board", {
                    params
                })
                .then(response => {
                    this.filterTreatmentOptions =
                        response?.data?.response?.resources?.filter_option;
                    this.treatments = get(
                        response,
                        "data.response.resources.data",
                        []
                    );
                    forEach(this.treatments, treatment => {
                        this.loadingTriageRow[treatment.id] = false;
                    });
                    return this.treatments;
                })
                .finally(() => {
                    this.loading = false;
                    this.isLoadingFilter = false;
                    this.preventLoading = false;
                    this.allowSwitchRefetch = true;
                });
        },
        getTreatment(targetId, treatmentDetails = true) {
            this.singleLoading = treatmentDetails;
            return this.$http
                .get(
                    process.env.BARRACUDA +
                        "schedule/treatment-board/" +
                        targetId
                )
                .then(response => {
                    if (response.status == 200) {
                        this.treatment = response.data.response.resources;

                        // Find the object by id
                        const index = this.treatments.findIndex(
                            treatment => treatment.id === targetId
                        );

                        let treatments = [...this.treatments];
                        if (!treatmentDetails && index !== -1) {
                            // Update the value
                            treatments[index] = {
                                ...this.treatment
                            };

                            this.treatments = [...treatments];
                        }
                    } else {
                        this._message(
                            response.message ||
                                response.statusText ||
                                "Failed to fetch patient's treatment information",
                            "danger"
                        );
                    }
                })
                .finally(() => {
                    this.singleLoading = false;
                });
        },
        refreshTreatmentBoard(treatment) {
            this.treatmentsFilter = treatment;
        },
        togglePopOver() {
            this.useNewTreatmentBoard
                ? this.$refs.filterTreatmentBoardV2.togglePopOver()
                : this.$refs.filterTreatmentBoard.togglePopOver();
        },
        filterData(filterSelectedObject) {
            this.filter = filterSelectedObject;
        },
        filterSelected(filterSelected) {
            this.filterSelect = filterSelected;
            if (
                this.useNewTreatmentBoard &&
                !this.isPatientView &&
                !this._isTvView
            ) {
                this.$refs.inputSearchIcon.resetSearch();
                this.searchPatient("");
            }
        },
        incrementKeyComponent() {
            this.keyComponent++;
        },
        async saveTreatmentBoardViewPreferences(value) {
            this.disableButton = true;
            await this.$store
                .dispatch("userPreferences/updatePref", {
                    category: "treatmentBoardView",
                    data: { showOld: value }
                })
                .finally(() => {
                    this.disableButton = false;
                });
        },
        activityAction(action, data) {
            this.$refs.newVitalModal?.$refs.multipleVitalModal.hide();
            this.$refs.startTaskModal?.$refs.startTaskModal.hide("cancel");
            this.$refs.summaryModal?.$refs.activitySummary.hide("cancel");
            this.$refs.createUpdateRecordModal?.$refs.createUpdateRecord.hide(
                "cancel"
            );

            // use treatment-activity-details.js mixin
            switch (action) {
                case "edit":
                case "reactivate":
                    this.edit(data);
                    break;
                case "duplicate":
                    this.duplicate(data);
                    break;
                case "deactivate":
                case "delete":
                    this.deleteModal(data);
                    break;
                case "history":
                    this.activityHistory(data);
                    break;
            }
        },
        searchPatient(value) {
            this.$refs.treatmentBoardNew?.searchPatients(value);
        },
        navigateToPatient(path) {
            this.$router.push(path);
        },
        async checkClinicInNewTreatmentBoardBeta(checkBeta = true) {
            this.isClinicInNewTreatmentBoardBeta = false;
            await AccountService.checkFeature("TREATMENT_BOARD_V2")
                .then(response => {
                    let isFeatureFlagAvailable = response?.message?.code;
                    if (isFeatureFlagAvailable) {
                        let isEnabled = response?.resource?.is_enabled;
                        this.isClinicInNewTreatmentBoardBeta = checkBeta
                            ? Boolean(isEnabled)
                            : true;
                        if (
                            !this.isClinicInNewTreatmentBoardBeta &&
                            this.isPatientView
                        ) {
                            this.$router.push({ name: "treatment" });
                        }
                    }
                })
                .catch(error => error.data);
        },
        oriTreatmentBoardRefresh(id) {
            if (id) {
                this.loadingTriageRow[id] = true;
            }

            setTimeout(() => {
                this.getTreatments().then(data => {
                    this.$socket.client.emit("v-broadcast", {
                        params: data.params,
                        instanceId: this.instanceId,
                        action: "refresh-treatment",
                        businessId: this._setting.business_id
                    });
                });
            }, 300);
        },
        newTreatmentBoardRefresh(params) {
            let treatmentId = null;
            let isRemove = false;
            let isRelatedToFilter = false;
            if (params && typeof params === "object") {
                treatmentId = params.treatment_board_id;
                isRemove = params.isRemove;
                isRelatedToFilter = params.isRelatedToFilter;
            }
            setTimeout(() => {
                let action = "refresh-treatment";
                if (this.isPatientView) {
                    treatmentId = this.treatment.id;
                    if (isRemove) {
                        this.$router.push({ name: "treatment" });
                        action = "reroute-treatment-details";
                    } else {
                        this.getTreatment(treatmentId, false);
                    }
                } else {
                    if (treatmentId && !isRelatedToFilter) {
                        this.getTreatment(treatmentId, false);
                    } else {
                        this.getTreatments(this.useNewTreatmentBoard);
                    }
                }
                this.$socket.client.emit("v-broadcast", {
                    instanceId: this.instanceId,
                    action: action,
                    businessId: this._setting.business_id,
                    treatmentId: treatmentId,
                    isRelatedToFilter: isRelatedToFilter
                });
            }, 300);
        }
    }
};
</script>
